import { render } from "./PlanesView.vue?vue&type=template&id=790cd89c"
import script from "./PlanesView.vue?vue&type=script&lang=js"
export * from "./PlanesView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__